class SwiperElement extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null; // To store the Swiper instance for cleanup
    this.resizeHandler = this.handleResize.bind(this); // Bind the resize handler
  }

  connectedCallback() {
    this.slidesPerView = this.getAttribute("data-slides-per-view") || "auto";
    const breakpointsAttr = this.getAttribute("data-breakpoints");
    this.breakpoints = breakpointsAttr ? this.parseBreakpoints(breakpointsAttr) : {};
    this.addSlideClasses();
    this.initSwiper();

    // Add resize listener
    window.addEventListener('resize', this.resizeHandler);
  }

  parseBreakpoints(breakpointsAttr) {
    try {
      return JSON.parse(breakpointsAttr);
    } catch (e) {
      console.error("Invalid breakpoints JSON:", e);
      return {};
    }
  }

  addSlideClasses() {
    const swiperWrapper = this.querySelector(".swiper-wrapper");
    if (swiperWrapper) {
      Array.from(swiperWrapper.children).forEach((child) => {
        child.classList.add("swiper-slide");
      });
    }
  }

  initSwiper() {
    if (typeof Swiper === 'undefined') return;
    this.swiperInstance = new Swiper(this, {
      slidesPerView: this.slidesPerView,
      scrollbar: { el: ".swiper-scrollbar" },
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      pagination: { el: ".swiper-pagination" },
      breakpoints: this.breakpoints,
      on: {
        reachBeginning: () => {
          if (this.querySelector(".swiper-button-prev")) {
            this.querySelector(".swiper-button-prev").style.setProperty("--display", "none");
          }
        },
        reachEnd: () => {
          if (this.querySelector(".swiper-button-next")) {
            this.querySelector(".swiper-button-next").style.setProperty("--display", "none");
          }
        },
        fromEdge: () => {
          if (this.querySelector(".swiper-button-prev")) {
            this.querySelector(".swiper-button-prev").style.setProperty("--display", "block");
          }
          if (this.querySelector(".swiper-button-next")) {
            this.querySelector(".swiper-button-next").style.setProperty("--display", "block");
          }
        },
      },
    });
    this.classList.add("swiper"); // Add class on initialization
  }

  handleResize() {
    if (this.swiperInstance) this.swiperInstance.update();
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null; 
      this.classList.remove("swiper"); // Remove class on destruction
    }
  }

  disconnectedCallback() {
    this.destroySwiper();
    window.removeEventListener('resize', this.resizeHandler); // Clean up the resize listener
  }
}

customElements.define("m-swiper", SwiperElement);